import React from 'react'

export const TopfirstIcon = () => {
    return (
        // <div className="layerTopRightIconWrapper">
        //     <div className="layerIconWrapperInsider">
        //         <div className="layerIconInsider">
        //             <div className="layerIconSvg">
        //                 <span style={{ marginLeft: '3px', marginTop: '4px', color: '#838383',fontSize:'15px',color:'#fff' }} className="material-icons iconss">first_page</span>
        //             </div>
        //         </div>
        //     </div>
        // </div>
        <></>
    )
}
export default TopfirstIcon;